import React from 'react';

import { HairTransplantPricesQuery } from '../interfaces';

type HairTransplantPricesProps = {
  packages: HairTransplantPricesQuery['hairTransplantPackages'];
};

const renderRichText = (content: any) => {
  if (!content || !content.children) return null;
  
  return content.children.map((node: any, index: number) => {
    if (node.type === 'paragraph') {
      return (
        <p key={index}>
          {node.children.map((child: any, childIndex: number) => {
            if (child.bold) {
              return <strong key={childIndex}>{child.text}</strong>;
            }
            return child.text;
          })}
        </p>
      );
    }
    return null;
  });
};

const HairTransplantPrices: React.FC<HairTransplantPricesProps> = ({ packages }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {packages.map((pkg, index) => (
        <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden transition duration-300 hover:shadow-lg border-t-4 border-blue-600">
          <div className="bg-gradient-to-r from-blue-600 to-teal-500 p-6 text-white">
            <h2 className="text-3xl font-bold mb-2">{pkg.title}</h2>
            <p className="text-lg opacity-90">Comprehensive Care Package</p>
          </div>
          <div className="p-6">
            {pkg.cards.map((card, cardIndex) => (
              <div key={cardIndex} className="mb-6">
                <div className="text-4xl font-bold text-blue-600 mb-4">{renderRichText(card.price?.raw)}</div>
                <ul className="space-y-3">
                  {card.cardItems.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start">
                      <svg className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                      </svg>
                      <span className="text-gray-700 text-lg">{item.feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HairTransplantPrices;
